import React from 'react'

import { CUSTOM_TEMPLATE } from '../../../_templates/Constants'
import { Label } from '../../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SliderInput from '../../../../../../components/form/SliderInput'

export const QrCodePosition = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![CUSTOM_TEMPLATE].includes(form.template)) return false

  return (
    <>
      <Label>Posição do QR Code em relação ao topo (cm)</Label>
      <SliderInput value={form.qrcodeTop} onChange={handleChange('qrcodeTop')} step="0.1" min="0" max="30" />

      <Separator weight={4} />

      <Label>Posição do QR Code em relação ao topo (cm)</Label>
      <SliderInput value={form.qrcodeLeft} onChange={handleChange('qrcodeLeft')} step="0.1" min="0" max="30" />

      <Separator weight={4} />
    </>
  )
}

export default QrCodePosition
